import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const HostCustomOfferBanner = ({ children, intl }) => {
  return (
    <div className="HostCustomOfferBanner margin-lg-top">
      <div className="flex space-between">
        <div className="details">
          <div className="flex space-between">
            <div className="h5 no-top-margin">
              <FormattedMessage
                id="inbox.host_custom_offer_banner.add_rentals"
                defaultMessage="Invite your guest to book"
              />
            </div>

            <div>
              <img
                className="visible-sm visible-xs extra-space-img"
                src="/web-2/assets/images/extra_space.svg?v=rb"
                alt={ intl.formatMessage({ id: 'inbox.host_custom_offer_banner.extra_space', defaultMessage: 'extra space' }) }
              />
            </div>
          </div>

          <p className="text-gray-600">
            <FormattedMessage
              id="inbox.host_custom_offer_banner.send_guest"
              defaultMessage="Pre-approve the guest's inquiry. You can adjust the booking details or add services before sending."
            />
          </p>

          <div>{ children }</div>
        </div>
      </div>
    </div>
  );
};

HostCustomOfferBanner.propTypes = {
  children: PropTypes.element,
  intl: intlShape,
  updateBooking: PropTypes.bool
};

export default injectIntl(HostCustomOfferBanner);
